<template>
  <div v-if="status == 'ok'">
    <div class="d-flex align-items-center">
      <div class="mr-auto d-md-block">
        <router-link to="/tickets/create" class="btn btn-success mx-2 px-4 py-2"
                style="border-radius: 20px;">
          <span class="pr-2">تیکت جدید</span>
        </router-link>
      </div>
    </div>

    <div class="bg-white py-3 my-2" style="border-radius: 10px;">

      <div class="px-3">
        <div class="table-responsive">
          <table class="table  table-responsive table-borderless text-center" v-if="status == 'ok'">
            <thead>
            <tr>
              <th scope="col" style="background-color: #eee;  border-radius: 0 16px 16px 0;">#</th>
              <th scope="col" style="background-color: #eee;">موضوع</th>
              <th scope="col" style="background-color: #eee;">دسته بندی</th>
<!--              <th scope="col" style="background-color: #eee">اولویت</th>-->
              <th scope="col" style="background-color: #eee;">تاریخ ایجاد</th>
              <th scope="col" style="background-color: #eee;">وضعیت</th>
              <th scope="col" style="background-color: #eee; border-radius:16px 0 0 16px ;">جزییات</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(ticket, index) in tickets.data" :key="index">
              <td class="en_num">{{ ticket.id }}</td>
              <td>{{ ticket.subject }}</td>
              <td>{{ ticket.category }}</td>
<!--              <td>-->
<!--                <span :class="'text text-lg  text-inline ' + 'text-' + priorityVariant(ticket.priority)">{{-->
<!--                    priorityStr.get(ticket.priority)-->
<!--                  }}</span>-->
<!--              </td>-->
              <td v-text="toPersianDateFormat(ticket.created_at)"></td>
              <td>
                <span :class="'label label-inline' + ' label-light-' + statusVariant(ticket.status)">{{
                    statusStr.get(ticket.status)
                  }}</span>
              </td>
              <td>
                <router-link :to="'/tickets/'+ ticket.id +'/comments'">
                  <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="#bbb">
                    <path d="M0 0h24v24H0V0z" fill="none"/>
                    <path d="M12 4C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                  </svg>
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <hr v-if="tickets.next_page_url || tickets.prev_page_url">

      <pagination :data="tickets" :get_data="get_data" :perpage="perpage"></pagination>
    </div>

    <div id="overlay" v-if="status == 'loading'">
      <div class="p-3" style="position: absolute;
  top: 50%;
  left: 50%;
  color: gray;
  background-color: white;
">


        <div class="spinner-border text-success" role="status">
        </div>
        <span>
          لطفا صبر کنید
        </span>


      </div>

    </div>

  </div>
</template>

<script>
import {ApiService} from "@/common/api.service";
import {statusStr, ticketStatus} from '@/constants/ticketStatus'
import {priorityStr} from "@/constants/priorityType";
import {statusVariant} from "@/constants/ticketStatus";
import {priorityVariant} from "@/constants/priorityType";
import $ from "jquery";
import Pagination from "@/components/main/pagination";
export default {
  components: {Pagination},
  props : ['action','ChangeStatus'],
  data() {
    return {
      perpage: {
        value: 15,
      },
      status: 'loading',
      tickets: null,
      filter_subject: null,
      filter_ticket_category: null,
      filter_status: null,
      filter_created_at: null,
      statusStr,
      priorityStr,
      statusVariant,
      priorityVariant,
      ticketStatus,
    }
  },
  computed: {
    query() {
      let res = '';
      if (this.filter_subject != null) {
        res = res + '&query[subject]=' + this.filter_subject;
      }
      if (this.filter_ticket_category != null) {
        res = res + '&query[category]=' + this.filter_ticket_category;
      }
      if (this.filter_status != null) {
        res = res + '&query[status]=' + this.filter_status;
      }

      if (this.filter_created_at != null) {
        res = res + '&query[created_at]=' + this.filter_created_at;
      }


      return res;
    }
  },
  methods: {
    toPersianDateFormat(val) {
      if (val == undefined || val == null || val == '') {
        return '';
      }

      val = String(val);

      return val.replace(/\-/g, "/");
    },
    resetQuery() {
      this.filter_subject = null
      this.filter_ticket_category = null
      this.filter_status = null
      this.filter_created_at = null

    },
    get_data(url, callback = () => {}) {
      this.status = 'loading'
      ApiService.query(url + this.query + '&perpage=' + this.perpage.value)
          .then(json => {
            this.tickets = json.data.data;
            this.status = 'ok'
            callback();
          })
    },
    reset_and_get() {
      this.resetQuery();
      this.get_data(this.tickets.path + '?page=1');
    },
  },
  mounted() {
    ApiService.get('ticket', '').then(json => {
      this.tickets = json.data.data;
      this.status = 'ok';
      this.ChangeStatus('ok');
    });
  }
}
</script>

<style>
#overlay {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 1000; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
</style>
